import { createContext, useContext } from 'react'

export const IntegrationAuthContext = createContext({
  isAuthenticated: false,
  isLoading: false,
  tokenData: null,
  refetchToken: () => {},
  integration: null
})

export const useIntegrationAuth = () => {
  const context = useContext(IntegrationAuthContext)
  if (!context) {
    throw new Error('useIntegrationAuth must be used within IntegrationAuthProvider')
  }
  return context
}
